import { channelModelFactory } from './channel-model-factory.js'

export const channelFactory = (dispatch, getState, channel, deviceId, moduleIndex, channelIndex, module, catalog) =>
  channelModelFactory(dispatch, getState, catalog, channel, deviceId, moduleIndex, channelIndex, module)
